import axios from '../../../build/http-requests/axios-common'

export default {
  state: {
    bankAccounttoEditId: null
  },

  mutations: {
    CLEAN_BANK_ACCOUNT_TO_EDIT (state) {
      state.bankAccounttoEditId = null
    },
    BANK_ACCOUNT_TO_EDIT_SELECTED (state, bankAccounttoEditId) {
      state.bankAccounttoEditId = bankAccounttoEditId
    }
  },

  actions: {
    getBankAccounts: ({ commit }, url) => {
      return new Promise((resolve, reject) => {
        axios.get(url).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    newBankAccount: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.post('/bankAccounts', data).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    setBankAccountToEdit: ({ commit }, bankAccountId) => {
      return new Promise((resolve, reject) => {
        commit('BANK_ACCOUNT_TO_EDIT_SELECTED', bankAccountId)
        resolve()
      })
    },

    cleanBankAccountToEdit: ({ commit }) => {
      return new Promise((resolve, reject) => {
        commit('CLEAN_BANK_ACCOUNT_TO_EDIT')
        resolve()
      })
    },

    getBankAccount: ({ commit }, bankAccountId) => {
      return new Promise((resolve, reject) => {
        axios.get('/bankAccounts/find', { params: { bankAccountId: bankAccountId } }).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    getBanks: ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios.get('/bankAccounts/banks').then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    getAccountsByGroup: ({ commit }, groupId) => {
      return new Promise((resolve, reject) => {
        axios.get('/bankAccounts/find/group', { params: { groupId } }).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    removeBankAccount: ({ commit }, bankAccountIdToRemove) => {
      return new Promise((resolve, reject) => {
        axios.delete('/bankAccounts', { params: { bankAccountId: bankAccountIdToRemove } }).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },
  getters: {
    bankAccounttoEditId: state => state.bankAccounttoEditId
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/bankAccounts.js